
import { defineComponent } from "vue";
import { useBreakpoints } from "JS/composables/breakpoint";

export default defineComponent({
	name: "OrderSummary",
	setup() {
		const { isDesktop } = useBreakpoints();
		return {
			isDesktop,
		};
	}
});
